export class CheckinAlreadyExistForUser extends Error {
    constructor(picacode) {
        super(`Checkin already done for picacode: ${picacode}`);
        this.picacode = picacode
    }

    getPicacode() {
        return this.picacode
    }
}

export class NextStepRequired extends Error {
    constructor(nextStep) {
        super(`Checkin need a new step: ${nextStep}`);
        this.nextStep = nextStep
    }

    getNextStep() {
        return this.nextStep
    }
}